import { render, staticRenderFns } from "./SupportiveEvidenceSection.vue?vue&type=template&id=2e18614d&scoped=true&"
import script from "./SupportiveEvidenceSection.vue?vue&type=script&lang=js&"
export * from "./SupportiveEvidenceSection.vue?vue&type=script&lang=js&"
import style0 from "./SupportiveEvidenceSection.vue?vue&type=style&index=0&id=2e18614d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18614d",
  null
  
)

export default component.exports